import { IMPRESSION_TRACKING_PATH, PriceSortQueryValue } from '@packages/common';
import {
  ImpressionMetadata,
  ImpressionsPayload,
  RecommendationImpressionMetadata,
  ViewPortSubscriberPayload,
  ProductImpression,
} from './types';

export const convertMetadataToPayload: (metadata: ImpressionMetadata) => Omit<ImpressionsPayload, 'products'> = (
  metadata: ImpressionMetadata,
) => {
  const { recommendationChannel, trackingIndice, categoryId, deviceType, segment, sortedList } =
    metadata as RecommendationImpressionMetadata;
  if (recommendationChannel || trackingIndice) {
    return {
      categoryId: `${categoryId}`,
      deviceType,
      segment,
      sortedList,
      c: recommendationChannel,
      t: trackingIndice,
    };
  }
  return { ...metadata, categoryId: `${categoryId}` };
};

export const getImpressionDataFromProduct = (
  payload: ViewPortSubscriberPayload,
  priceSort: PriceSortQueryValue,
): ProductImpression | null => {
  if (!payload || !payload.item) {
    return null;
  }

  const { partner, productId, isDYRecommended } = payload.item;
  return {
    partnerId: partner.id || '',
    productId,
    position: payload.index,
    localProduct: false,
    dy: priceSort === PriceSortQueryValue.NONE ? !!isDYRecommended : false,
  };
};

export type SendImpressions = (payload: any) => Promise<any>;

export const sendImpressions: SendImpressions = async (payload) => {
  let response;
  try {
    response = await fetch(IMPRESSION_TRACKING_PATH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
  } catch (error) {
    // network error
    console.error('impressions fetch error', error);
  }

  return response;
};
